/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  Label,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  FormText,
  Button,
  Alert
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { FirebaseContext } from "common";
import CustomDropDownPicker from "components/CustomDropDownPicker";
import { features, language, STYLES } from "config";
import { usersreducer } from "common/src/reducers/usersreducer";

const BrokerProfile = () => {
  const userManagementReducer = useSelector((state) => state.usersdata)
  const { api } = useContext(FirebaseContext);
  const { editUserSharedBrokers, clearUserErrors } = api;
  const auth = useSelector((state) => state.auth);
  const brokers = useSelector((state) => state.brokers.users);
  const areaData = useSelector((state) => state.areaData);
  const activeListingsByBranch = useSelector(
    (state) => state.ListingData.activeListingsByBranch
  );
  const inactiveListingsByBranch = useSelector(
    (state) => state.ListingData.inactiveListingsByBranch
  );
  const activeBranchEnquiries = useSelector(
    (state) => state.enquirydata.activeBranchEnquiries
  );
  const inactiveBranchEnquiries = useSelector(
    (state) => state.enquirydata.inactiveBranchEnquiries
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  let brokerInfomation = location.state; // Retrieve passed branch data
  const areas = areaData.areas;

  const [brokerActiveListings, setBrokerActiveListings] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [brokerInactiveListings, setBrokerInactiveListings] = useState([]);
  const [brokerActiveEnquiries, setBrokerActiveEnquiries] = useState([]);
  const [brokerInactiveEnquiries, setBrokerInactiveEnquiries] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [currentShareBrokers, setCurrentShareBrokers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [sharedBrokers, setSharedBrokers] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [value, setValue] = useState([]);
  const [edit, setEdit] = useState(true);

  const updateUser = (selectedShareBrokers) => {
    if (!selectedShareBrokers || currentShareBrokers.length === 0) {
      alert("Please select at least one broker to share");
      return;
    }

    console.log("selected", selected)
    console.log("currentShareBrokers", currentShareBrokers)

    const currentShareBrokersIds = currentShareBrokers.map((b) => b.value)

    const sharedBrokersUpdate = [...currentShareBrokersIds, ...selected]

    console.log("sharedBrokersUpdate", sharedBrokersUpdate)

    dispatch(editUserSharedBrokers(brokerInfomation.id, sharedBrokersUpdate));
    alert(
      `Updated shared brokers of ${brokerInfomation.firstName} ${brokerInfomation.lastName}`
    );
    setEdit(true)
  };

  function GetBrokerListings() {
    let active = [];
    let inactive = [];

    if (activeListingsByBranch) {
      active = activeListingsByBranch.filter(
        (listing) => brokerInfomation.id === listing.userdetials?.id
      );
    }

    if (inactiveListingsByBranch) {
      inactive = inactiveListingsByBranch.filter(
        (listing) => brokerInfomation.id === listing.userdetials?.id
      );
    }

    setBrokerActiveListings(active);
    setBrokerInactiveListings(inactive);
  }

  useEffect(() => {
    clearUserErrors()
  })

  useEffect(() => {
    if (brokerInfomation) {
      console.log("broker info:", brokerInfomation.SharedBrokers)
    }

  }, [brokerInfomation])

  useEffect(() => {

    if(userManagementReducer.currentUser){
      brokerInfomation = userManagementReducer.currentUser
    }
    
    console.log("Brokers from state:", brokerInfomation);
    if (!brokers || !brokerInfomation) return;

    let arr = [];
    const initialSelected = [];

    for (let index = 0; index < brokers.length; index++) {
      const element = brokers[index];

      // Only include brokers from the same home office
      if (
        element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice &&
        element.id !== brokerInfomation.id
      ) {
        // Don't include self
        const brokerOption = {
          value: element.id,
          label: `${element.firstName} ${element.lastName}`
        };
        arr.push(brokerOption);

        // Check if this broker is already shared
        if (
          brokerInfomation?.SharedBrokers &&
          brokerInfomation.SharedBrokers.includes(element.id)
        ) {
          initialSelected.push(brokerOption);
        }
      }
    }

    setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
    setValue(initialSelected);
    setCurrentShareBrokers(initialSelected)
  }, [brokerInfomation, userManagementReducer.currentUser]);

  function GetBrokerEnquiries() {
    let active = [];
    let inactive = [];

    if (activeBranchEnquiries) {
      active = activeBranchEnquiries.filter(
        (enquiry) => brokerInfomation.id === enquiry.userdetials?.id
      );
    }

    if (inactiveBranchEnquiries) {
      inactive = inactiveBranchEnquiries.filter(
        (enquiry) => brokerInfomation.id === enquiry.userdetials?.id
      );
    }

    setBrokerActiveEnquiries(active);
    setBrokerInactiveEnquiries(inactive);
  }

  useEffect(() => {
    if (!brokerInfomation || !areas) return;

    let arr = [];
    const brokerAreas = brokerInfomation.Areas || [];
    console.log(
      `Brokers areas total: ${brokerAreas.length}`,
      typeof brokerAreas,
      JSON.stringify(brokerAreas)
    );

    if (brokerAreas.length === 0) {
      console.log("No broker areas found for this user.");
      setAreaList([]);
      return;
    }

    // Convert brokerAreas to an array if it's an object
    const brokerAreaIds =
      typeof brokerAreas === "object" && !Array.isArray(brokerAreas)
        ? Object.keys(brokerAreas)
        : brokerAreas;

    // Filter areas based on areaId match
    arr = areas.filter(
      (area) =>
        brokerAreaIds.includes(area.areaId) ||
        brokerAreaIds.includes(area.Location) // Fallback for legacy data
    );

    setAreaList(arr);
    console.log("Area List:", arr);
  }, [areas, brokerInfomation]);

  useEffect(() => {
    GetBrokerListings();
    GetBrokerEnquiries();
  }, [
    activeListingsByBranch,
    inactiveListingsByBranch,
    activeBranchEnquiries,
    inactiveBranchEnquiries
  ]);

  // When the state is updated, set isDataLoaded to true
  useEffect(() => {
    if (brokerActiveListings.length > 0 || brokerInactiveListings.length > 0) {
      setIsDataLoaded(true);
    }
  }, [brokerActiveListings, brokerInactiveListings]);

  // Handle selection change from dropdown
  const handleBrokerSelection = (selectedItems) => {
    console.log("selected items:", selectedItems)
    setEdit(false);
    setValue(selectedItems);
    setSelected(selectedItems);
  };

  // Handle selection change from dropdown
  const handleRemoveShareBroker= (item) => {
    console.log("item:", item)
    setCurrentShareBrokers(item);
  };

  /////////////////////////////////////////////////__Picutre Upload__///////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return auth.loading ? (
    <CircularLoading />
  ) : (
    <>
      <Row className="mb-4">
        <Col md="12">
          <Card className="card-user">
            <CardHeader className="text-center">
              <CardTitle tag="h3">Broker Profile</CardTitle>
            </CardHeader>
            <CardBody>
              <div className="author text-center">
                <div className="picture mb-3">
                  <img
                    src={
                      brokerInfomation.profile_image || "/default-avatar.png"
                    }
                    className="picture-src rounded-circle"
                    alt="..."
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover"
                    }}
                  />
                </div>
                <h4 className="title">
                  {brokerInfomation.firstName} {brokerInfomation.lastName}
                </h4>
                <p className="description">{brokerInfomation.practiceName}</p>
                <p className="description text-capitalize">
                  {brokerInfomation.userType}
                </p>
                <p className="description">{brokerInfomation.email}</p>
                <p className="description">{brokerInfomation.mobile}</p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        {/* Statistics Card - Listings */}
        <Col md="6" lg="3" className="mb-4">
          <Card
            className="h-100 text-center"
            style={{
              border: "2px solid",
              borderColor: STYLES.PRIMARY_APP_CLR,
              borderRadius: "15px"
            }}
          >
            <CardHeader style={{ backgroundColor: STYLES.PRIMARY_APP_CLR }}>
              <CardTitle tag="h5" className="mb-0 text-white">
                BROKER LISTINGS
              </CardTitle>
            </CardHeader>
            <CardBody className="d-flex flex-column">
              <div className="my-2">
                <h3 style={{ color: STYLES.TERTIARY_APP_CLR }}>
                  {brokerActiveListings.length + brokerInactiveListings.length}
                </h3>
                <p className="mb-0">Total Listings</p>
              </div>
            </CardBody>
            <CardFooter className="bg-transparent d-flex flex-column">
              <Button
                color="primary"
                className="mb-2"
                onClick={() =>
                  navigate("/stock", { state: brokerActiveListings })
                }
                disabled={brokerActiveListings.length === 0}
                block
              >
                Active: {brokerActiveListings.length}
              </Button>
              <Button
                color="secondary"
                onClick={() =>
                  navigate("/stock", { state: brokerInactiveListings })
                }
                disabled={brokerInactiveListings.length === 0}
                block
              >
                Inactive: {brokerInactiveListings.length}
              </Button>
            </CardFooter>
          </Card>
        </Col>

        {/* Statistics Card - Enquiries */}
        <Col md="6" lg="3" className="mb-4">
          <Card
            className="h-100 text-center"
            style={{
              border: "2px solid",
              borderColor: STYLES.PRIMARY_APP_CLR,
              borderRadius: "15px"
            }}
          >
            <CardHeader style={{ backgroundColor: STYLES.PRIMARY_APP_CLR }}>
              <CardTitle tag="h5" className="mb-0 text-white">
                BROKER ENQUIRIES
              </CardTitle>
            </CardHeader>
            <CardBody className="d-flex flex-column">
              <div className="my-2">
                <h3 style={{ color: STYLES.TERTIARY_APP_CLR }}>
                  {brokerActiveEnquiries.length +
                    brokerInactiveEnquiries.length}
                </h3>
                <p className="mb-0">Total Enquiries</p>
              </div>
            </CardBody>
            <CardFooter className="bg-transparent d-flex flex-column">
              <Button
                color="primary"
                className="mb-2"
                onClick={() =>
                  navigate("/enquiries", {
                    state: brokerActiveEnquiries
                  })
                }
                disabled={brokerActiveEnquiries.length === 0}
                block
              >
                Active: {brokerActiveEnquiries?.length || 0}
              </Button>
              <Button
                color="secondary"
                onClick={() =>
                  navigate("/enquiries", {
                    state: brokerInactiveEnquiries
                  })
                }
                disabled={brokerInactiveEnquiries.length === 0}
                block
              >
                Inactive: {brokerInactiveEnquiries?.length || 0}
              </Button>
            </CardFooter>
          </Card>
        </Col>

        {/* Multi Select Component - Share Brokers */}
        <Col md="6" lg="3" className="mb-4">
          <Card
            className="h-100"
            style={{
              border: "2px solid",
              borderColor: STYLES.PRIMARY_APP_CLR,
              borderRadius: "15px"
            }}
          >
            <CardHeader style={{ backgroundColor: STYLES.PRIMARY_APP_CLR }}>
              <CardTitle tag="h5" className="mb-0 text-white">
                SHARE BROKERS
              </CardTitle>
            </CardHeader>
            <CardBody>
              <div className="mb-3">
                <Label className="font-weight-bold">Currently Shared:</Label>
                {currentShareBrokers.length > 0 ? (
                  <div className="mt-2">
                    {currentShareBrokers.map((broker, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between mb-2 p-2 bg-light rounded"
                      >
                        <span>{broker.label}</span>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => {
                            const updated = currentShareBrokers.filter(
                              (b) => b.value !== broker.value
                            );
                            handleRemoveShareBroker(updated);
                            setEdit(false);
                          }}
                        >
                          Remove
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted mt-2">No brokers shared yet</p>
                )}
              </div>

              <div>
                <Label className="font-weight-bold">Add More Brokers:</Label>
                {brokerList && brokerList.length > 0 ? (
                  <CustomDropDownPicker
                    value={value}
                    setValue={handleBrokerSelection}
                    options={brokerList}
                    isMulti={true}
                    onChange={handleBrokerSelection}
                  />
                ) : (
                  <FormText color="muted" className="mt-2">
                    No brokers available
                  </FormText>
                )}
              </div>
            </CardBody>
            <CardFooter className="bg-transparent">
              <Button
                color="primary"
                onClick={() => updateUser(selected)}
                disabled={edit === true}
                block
              >
                Update Shared Brokers
              </Button>
            </CardFooter>
          </Card>
        </Col>

        {/* Statistics Card - Areas */}
        <Col md="6" lg="3" className="mb-4">
          <Card
            className="h-100 text-center"
            style={{
              border: "2px solid",
              borderColor: STYLES.PRIMARY_APP_CLR,
              borderRadius: "15px"
            }}
          >
            <CardHeader style={{ backgroundColor: STYLES.PRIMARY_APP_CLR }}>
              <CardTitle tag="h5" className="mb-0 text-white">
                BROKER AREAS
              </CardTitle>
            </CardHeader>
            <CardBody className="d-flex flex-column">
              <div className="my-2">
                <h3 style={{ color: STYLES.TERTIARY_APP_CLR }}>
                  {areaList.length}
                </h3>
                <p className="mb-0">Total Areas</p>
              </div>
            </CardBody>
            <CardFooter className="bg-transparent">
              <Button
                color="primary"
                onClick={() =>
                  navigate("/brokerareamanagement", { state: areaList })
                }
                disabled={areaList.length === 0}
                block
              >
                View Areas
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default BrokerProfile;
